<div (mouseenter)="tooltip.onHover()" (mouseleave)="tooltip.onExit()" *ngIf="tooltip.type === 'external'" [style]="positionStyle"
     class="ui-tooltip-top"
     id="container">
  <div class="ui-tooltip-arrow"></div>
  <div id="content">
    <div [innerHTML]="tooltip.content" style="font-size: 0.75em"></div>
    <div style="font-size: 0.75em; text-align: center"><a (click)="tabbingService.interceptClickEvent($event)" [href]="tooltip.link"
                                                          target="_blank">View
      External
      Documentation</a></div>
  </div>
</div>
